export class LoginModal {
  employeeId?: string;

  sdcCardNo?: string;
}
